import { useContext, useEffect, useRef } from 'react';
import { toast, ToastOptions } from 'react-toastify';
import { useIsOnline } from './useIsOnline';
import { LangContext } from '@/context/LangProvider';

const baseToastOptions: ToastOptions = {
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
};

const offlineToastOptions: ToastOptions = {
  ...baseToastOptions,
  autoClose: false,
};

const onlineToastOptions: ToastOptions = {
  ...baseToastOptions,
  autoClose: 3000,
};

export function useNetworkStatus() {
  const isOnline = useIsOnline();
  const wentOffline = useRef(false);
  const toastIdRef = useRef<string | number | null>(null);
  const { lang } = useContext(LangContext);

  useEffect(() => {
    if (!isOnline) {
      wentOffline.current = true;
      toastIdRef.current = toast.error(lang.get('msg.noInternetConnection'), offlineToastOptions);
    } else if (wentOffline.current) {
      if (toastIdRef.current) toast.dismiss(toastIdRef.current);
      toast.success(lang.get('msg.internetConnectionRestored'), onlineToastOptions);
      wentOffline.current = false;
      toastIdRef.current = null;
    }

    return () => {
      if (toastIdRef.current) toast.dismiss(toastIdRef.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOnline]);
}
